<template>
   <!-- 新增标签 -->
  <el-dialog
    :title="title"
    :visible.sync="awaitShow"
    width="600px"
    class="await-dialog"
    :before-close="handleClose">
    <div class="await-cont">
      <img src="../../../assets/images/await.png" alt="">
      <p>正在研发当中，敬请期待！</p>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props:['title','awaitShow'],
  data () {
    return {
      show:false
    }
  },
  watch:{
    awaitShow(val){
      this.show=this.awaitShow
    }
  },
  created () {
    
  },
  beforeDestroy () {
    
  },
  mounted () {
   
  },
  computed:{
    
  },
  methods: {
    
    
    handleClose(){
      this.show=false
      this.$emit('initFuc')
    }
    
  }
}
</script>
<style>
.await-dialog .el-dialog__header{
  padding:12px 15px;
  background: #F0F2F5;
  border-radius: 3px 3px 0 0;
  border-radius: 3px 3px 0px 0px;
}
.await-dialog .el-dialog__header .el-dialog__headerbtn {
    top: 12px;
}
.await-dialog .el-dialog__body{
  padding: 20px;
}
.await-dialog .el-dialog__title{
  
  font-size: 16px;
  color: #303133;
  text-align: left;
  line-height: 24px;
}
.await-dialog .el-dialog__footer{
  text-align: center;
  padding-bottom: 15px;
}
.await-dialog .el-dialog__footer .el-button{
  padding: 8px 15px;
  font-size: 12px;
  line-height: 16px;
}
.await-dialog .el-dialog__footer .el-button--primary{ 
  background: #2E8AF1;
  border-color: #2E8AF1;
}
.await-dialog .el-dialog__footer .el-button--primary:focus, .await-dialog .el-dialog__footer .el-button--primary:hover {
    background: #66b1ff;
    border-color: #66b1ff;
}
.await-dialog .el-dialog__footer .el-button--default{
  color: #606266;
}
.await-dialog .el-dialog__footer .el-button--default:hover,.await-dialog .el-dialog__footer .el-button--default:focus{
  color: #2E8AF1;
}

.await-dialog .el-form-item{
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  margin-bottom: 15px;
}
.await-dialog .el-form-item__label{
  font-size: 12px;
  color:#909399;
  font-weight: normal;
  padding-right: 5px;
}
.await-dialog .el-form-item .el-input{
  width: 240px;
  font-size: 12px;
}
.await-dialog .el-form-item .el-radio__label{
  font-size: 12px;
}
.await-dialog .el-form-item .el-cascader{
  font-size: 12px;
}
.await-dialog .el-form-item .el-input__inner{
  font-size: 12px;
  width: 240px;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}
.await-dialog .el-radio__input.is-checked+.el-radio__label{
  color:#2E8AF1
}
.await-dialog .el-radio__input.is-checked .el-radio__inner {
    border-color: #2E8AF1;
    background: #2E8AF1;
}
.await-dialog .el-dialog__headerbtn:focus .el-dialog__close,.await-dialog .el-dialog__headerbtn:hover .el-dialog__close{
  color:#2E8AF1
}
.el-cascader-menu__item.is-active{
  color:#2E8AF1
}
.await-dialog .await-cont{
  padding: 60px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/awaitDialog.vue